import fetchPaymentGateways from './fetchPaymentGateways';
import fetchPaymentGatewayById from './fetchPaymentGatewayById';
import createPaymentGateway from './createPaymentGateway';
import updatePaymentGateway from './updatePaymentGateway';
import deletePaymentGateway from './deletePaymentGateway';
import performPaymentGatewayAction from './performPaymentGatewayAction';

// Webhook related actions
import fetchPaymentGatewayWebhooks from './fetchPaymentGatewayWebhooks';
import createPaymentGatewayWebhook from './createPaymentGatewayWebhook';
import updatePaymentGatewayWebhook from './updatePaymentGatewayWebhook';
import deletePaymentGatewayWebhook from './deletePaymentGatewayWebhook';
import fetchPaymentGatewayWebhookEvents from './fetchPaymentGatewayWebhookEvents';

import fetchAvailablePaymentGateways from './fetchAvailablePaymentGateways';
import fetchAvailablePaymentMethods from './fetchAvailablePaymentMethods';
import fetchAvailableChargeStatus from './fetchAvailableChargeStatus';

export default {
  fetchPaymentGateways,
  fetchPaymentGatewayById,
  createPaymentGateway,
  updatePaymentGateway,
  deletePaymentGateway,
  performPaymentGatewayAction,

  // Webhook related actions
  fetchPaymentGatewayWebhooks,
  createPaymentGatewayWebhook,
  updatePaymentGatewayWebhook,
  deletePaymentGatewayWebhook,
  fetchPaymentGatewayWebhookEvents,

  fetchAvailablePaymentGateways,
  fetchAvailablePaymentMethods,
  fetchAvailableChargeStatus,
};
